import { ScenarioBuilderClient } from "@/pages/scenario-builder/api/client/scenarioClient";
import { useScenarioBuilderClient } from "@/pages/scenario-builder/api/hooks/useScenarioBuilderClient";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

type DeleteActionPlanOptions = {
  scenarioBuilderClient: ScenarioBuilderClient;
  actionPlanUuid: string;
};

const deleteActionPlan = ({ scenarioBuilderClient, actionPlanUuid }: DeleteActionPlanOptions) => {
  return scenarioBuilderClient.actionPlans.deleteActionPlan({
    actionPlanUuid,
  });
};

export const useDeleteActionPlan = () => {
  const scenarioBuilderClient = useScenarioBuilderClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (actionPlanUuid: string) =>
      deleteActionPlan({ scenarioBuilderClient, actionPlanUuid }),
    onSuccess: () => {
      toast.success("Action plan deleted successfully!");
      queryClient.invalidateQueries({ queryKey: ["action-plans"] });
    },
    onError: (error) => {
      toast.error("Failed to delete action plan. Please try again.");
      console.error("useDeleteActionPlan onError", error);
    },
  });
};
